import { Checkbox, FormControlLabel, FormGroup, TextField, Typography } from "@material-ui/core";
import { Select, MenuItem } from "@mui/material";
import React, {useEffect, useState} from "react";

import { CheckCircle, Error } from "@mui/icons-material";

const AddBuildingRow = (props) => {
    let [name, setName] = useState()
    let [ownership, setOwnership] = useState("Owned")
    let [floors, setFloors] = useState(1)
    let [hasBasement, setHasBasement] = useState(false)
    let [sqft, setSqft] = useState()
    let [height, setHeight] = useState(props.building.floor_to_ceiling_height)

    let [building, setBuilding] = useState(props.building)


    const updateForm = () => {
        let updatedBuilding = Object.assign({}, building)
        updatedBuilding.name = name
        updatedBuilding.ownership_status = ownership
        updatedBuilding.floors = floors
        updatedBuilding.area = parseInt(sqft)
        updatedBuilding.volume =  sqft && height ? parseInt(sqft) * parseInt(height) : 0
        updatedBuilding.hasBasement = hasBasement

        props.callback(props.row_num, updatedBuilding)
    }

    useEffect(() => {
        updateForm();
    },[name, ownership, floors, sqft, height, hasBasement])

    let className = props.building.error ? "add-row row-toast" : "add-row" 
    return (
        <div className={className}>
            <div className="row-error">{props.building.error}</div>
            <div className="row-form-field">
                <TextField label="Name" variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}} required/>
            </div>
            <div className="row-form-field">
                <TextField type="number" label="# of Floors" defaultValue={1} variant="outlined" size="small" onChange={(e) => {setFloors(e.target.value)}} required />
            </div>
            <div className="row-form-field">
                <TextField type="number" label="Sq. Ft." variant="outlined" size="small" onChange={(e) => {setSqft(e.target.value)}}/>
            </div>
            <div className="row-form-field">
                <TextField type="number" label="Ceiling Height" defaultValue={props.building.floor_to_ceiling_height} variant="outlined" size="small" onChange={(e) => {setHeight(e.target.value)}}/>
            </div>
            <div className="row-form-field">
                <Select
                    id="ownership"
                    size="small"
                    defaultValue="Owned"
                    label="Ownership"
                    onChange={(value) => {setOwnership(value)}}
                >
                    <MenuItem value="Owned">Owned</MenuItem>
                    <MenuItem value="Leased">Leased</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                </Select>
            </div>
            <div className="row-form-field">
                <FormGroup>
                    <FormControlLabel control={<Checkbox variant="outlined" size="small" onChange={(e) => setHasBasement(e.target.checked)} />} label="Has Basement?" styles={{fontSize: 12}} />
                </FormGroup>
            </div>
            {
                props.success ? <CheckCircle /> : props.failure ? <Error /> : null
            }

        </div>
    )
}

export default AddBuildingRow;